import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    detectSessionInUrl: true,
  },
});

const BASE = 'https://app.tablechat-ai.com/api/portal';

// Always returns a fresh token — avoids calling getSession()
// when the caller already has a token from onAuthStateChange.
export async function getValidToken() {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) {
    console.error('[portal] getSession error:', error.message);
    return null;
  }
  return session?.access_token ?? null;
}

export async function portalFetch(path, options = {}, _legacyToken = null) {
  const token = await getValidToken();
  if (!token) {
    console.error('[portal] portalFetch: no session for', path);
    return null;
  }
  try {
    const res = await fetch(`${BASE}${path}`, {
      ...options,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: res.statusText }));
      console.error(`[portal] ${path} ${res.status}:`, err.error);
      return null;
    }
    return res.json();
  } catch (err) {
    console.error(`[portal] ${path} fetch error:`, err.message);
    return null;
  }
}

export const setPortalToken = () => {};
export const getPortalToken = () => null;

// FIX: Accepts token directly from onAuthStateChange to avoid lock contention.
// Falls back to getValidToken() only if no token is provided.
export async function getMyRestaurant(userId, token = null) {
  const accessToken = token ?? await getValidToken();
  if (!accessToken) return null;
  try {
    const res = await fetch(`${BASE}/restaurant`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return { ...data.restaurant, role: data.role };
  } catch {
    return null;
  }
}
